// DAAM — frontend Sentry initialisation.
//
// Fully disabled when REACT_APP_SENTRY_DSN is missing/blank. No network
// calls, no side effects. Called once from src/index.js before React
// mounts so uncaught errors during the initial render are captured.
//
// PII policy: sendDefaultPii=false, no user identifiers or request bodies
// are attached to events. Validation / 4xx responses from the backend are
// dropped in beforeSend so they don't appear as application exceptions.
import * as Sentry from '@sentry/react';

const HEALTH_VERSION = 'launch-blocker-3-health-2026-02-24';

export function initSentry() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
  if (!dsn) {
    return { enabled: false, reason: 'no_dsn' };
  }
  try {
    Sentry.init({
      dsn,
      environment: (process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production').trim(),
      release: (process.env.REACT_APP_SENTRY_RELEASE || HEALTH_VERSION).trim(),
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
      sendDefaultPii: false,
      // Filter validation / expected-4xx errors surfaced through fetch
      // wrappers so they don't page as application exceptions.
      beforeSend(event, hint) {
        try {
          const err = hint && hint.originalException;
          const status = err && (err.status || err.statusCode || (err.response && err.response.status));
          if (typeof status === 'number' && status >= 400 && status < 500) {
            return null;
          }
        } catch (_e) {
          // If our filter breaks, forward the event.
        }
        return event;
      },
    });
    return { enabled: true, reason: 'ok' };
  } catch (e) {
    return { enabled: false, reason: 'init_failed' };
  }
}

export { Sentry };
